import React from 'react';

import LabelInfo from '../../../../../components/LabelInfo';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { ACCOUNT_USER_ORDER_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/accountUserConstants';
import { setNumberWithComma } from '../../../../../lib/common';
import { ACCOUNT_USER_DETAIL_ORDER_HISTORY_LIST_FILTER_OPTION_MODEL } from './models';
import { columns } from './columns';
import { useAccountUserDetailOrderList, useAccountUserOrderDetail } from './hooks';

const AccountUserDetailOrderInfo = (props) => {
  const { userId, isActive } = props;

  const orderSummaryData = useAccountUserOrderDetail({ userId, isActive });
  const { orderHistoryList, pagination, filterOption, setPagination, setFilterOption } = useAccountUserDetailOrderList({
    userId,
    isActive,
  });

  //주문 리스트 가져오기
  const getOrderList = (data) => {
    const { filterOption, pagination } = data;

    pagination && setPagination(pagination);
    filterOption && setFilterOption(filterOption);
  };

  return (
    <div className="account-user-detail-content">
      {/* 주문 통계*/}
      <div className="account-user-detail-section">
        <div className="title">주문 통계</div>

        <div className="account-user-detail-section-content">
          <div className="form-wrap">
            <LabelInfo label="주문 결제 금액" info={setNumberWithComma(orderSummaryData.orderPaymentAmount, '원')} />

            <LabelInfo label="주문 결제 횟수" info={setNumberWithComma(orderSummaryData.orderPaymentCnt)} />
          </div>

          <div className="form-wrap">
            <LabelInfo label="주문 취소 금액" info={setNumberWithComma(orderSummaryData.orderCancelAmount, '원')} />

            <LabelInfo label="주문 취소 횟수" info={setNumberWithComma(orderSummaryData.orderCancelCnt)} />
          </div>

          <div className="form-wrap">
            <LabelInfo label="누적 반품 횟수" info={setNumberWithComma(orderSummaryData.orderReturnCnt)} />

            <LabelInfo label="누적 교환 횟수" info={setNumberWithComma(orderSummaryData.orderExchangeCnt)} />
          </div>
        </div>
      </div>

      {/* 주문 내역 리스트*/}
      <div className="account-user-detail-section">
        <div className="title">주문 내역 리스트</div>

        <div className="account-user-detail-section-content">
          <TableWithSummary
            className="account-user-detail-section-list"
            data={orderHistoryList.list}
            totalCnt={orderHistoryList.totalCnt}
            initialOption={{
              filterOption: ACCOUNT_USER_DETAIL_ORDER_HISTORY_LIST_FILTER_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            }}
            isStriped={true}
            emptyText={ACCOUNT_USER_ORDER_LIST_TABLE_EMPTY_TEXT}
            showPagination
            filterOption={filterOption}
            pagination={pagination}
            getList={getOrderList}
            maxHeight={1200}
            columns={(utils) =>
              columns({
                ...utils,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AccountUserDetailOrderInfo;
